import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProductsHistoryComponent } from '@routes/dialogs/products-history/products-history.component';
import Utils from '@shared/utils/utils';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '@shared/services/spinner.service';
import { ApiService } from '@shared/apis';
import { finalize } from 'rxjs/operators';
import { TicketManager } from '@routes/ticket-manager';
import { Product } from '@shared/models/product';
import { Company } from '@shared/enums/company';
import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-products-view',
  templateUrl: './products-view.component.html',
  styleUrls: ['./products-view.component.scss']
})
export class ProductsViewComponent implements OnInit {
  @Output() changeView = new EventEmitter();
  productList: Product[] = [];
  bsModalRef: BsModalRef;

  company;
  companies = Company;
  showCreateTicketButton = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private spinnerService: SpinnerService,
              private ticketManager: TicketManager,
              private apiService: ApiService,
              private authService: AuthService,
              private modalService: BsModalService) {
    this.company = this.authService.getCurrentCompany();
  }

  _dealerStore: any;

  get dealerStore() {
    return this._dealerStore;
  }

  @Input()
  set dealerStore(value) {
    if (value) {
      this._dealerStore = value;
      this.getProductView();
    }
  }

  ngOnInit(): void {
    this.showCreateTicketButton = this.companies.Sea === this.company;
  }

  getProductView() {
    const { _id } = this.dealerStore;
    this.spinnerService.start();
    this.apiService.ticket.getProductView(_id)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.productList = res;
      }, err => Utils.showError(err));
  }

  repairHistory(product) {
    const initialState = {
      product,
      title: 'Repair History',
    };

    this.modalService.show(ProductsHistoryComponent, { initialState, class: 'modal-1036px' });
  }

  removeProduct({ dealerStore, serialNo, modelCode }: Product) {
    this.spinnerService.start();
    this.apiService.ticket.removeProduct(dealerStore, serialNo, modelCode)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.getProductView();
      }, err => Utils.showError(err));
  }

  requestService(product: any) {
    const ticketInfo: any = {
      tempProduct: product,
      status: 'product',
    };
    this.ticketManager.addTicket(ticketInfo);
  }
}
